// Dates & times the way the DEVICE shows them: its time zone, and its 12 h / 24 h setting.
// The words follow the app language (EN / FR); the clock style follows the phone / computer.
const deviceHour12 = (() => {
  try { return new Intl.DateTimeFormat(undefined, { hour: 'numeric' }).resolvedOptions().hour12; } catch (e) { return undefined; }
})();
const locale = (lang) => (lang === 'fr' ? 'fr-CA' : 'en-CA');

// e.g. "Sun, Oct 4, 3:00 a.m." (or "Sun, Oct 4, 03:00" on a 24 h device)
export const fmtDateTime = (iso, lang) => (iso ? new Date(iso).toLocaleString(locale(lang), {
  weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: deviceHour12,
}) : '');
// e.g. "7:30 p.m." / "19:30"
export const fmtTime = (iso, lang) => (iso ? new Date(iso).toLocaleTimeString(locale(lang), { hour: 'numeric', minute: '2-digit', hour12: deviceHour12 }) : '');
